import { useEffect, useRef } from 'react';

/**
 * A thin accent-colored bar at the top of the viewport showing scroll progress.
 * Used on inner pages (not the cinematic home). Reads window.scrollY in rAF
 * and updates a CSS transform — no React state churn.
 */
export function ScrollProgress() {
  const barRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    let raf = 0;
    const update = () => {
      const bar = barRef.current;
      if (!bar) return;
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      const progress = max > 0 ? Math.max(0, Math.min(1, window.scrollY / max)) : 0;
      bar.style.transform = `scaleX(${progress})`;
      raf = requestAnimationFrame(update);
    };
    raf = requestAnimationFrame(update);
    return () => cancelAnimationFrame(raf);
  }, []);

  return <div ref={barRef} className="scroll-progress" aria-hidden="true" />;
}
